import React from 'react';

const Button = ({
  type = 'button',
  disabled,
  children,
  className = '',
  ...props
}) => {
  return (
    <button
      type={type}
      disabled={disabled}
      className={`bg-primary flex cursor-pointer items-center justify-center gap-2 rounded-lg px-4 py-2 text-white transition-all disabled:cursor-not-allowed disabled:opacity-75 ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
